import cssUtil from 'gw-portals-util-js/CssUtil';

import templateStr from 'text!./FacebookSharingDirective.html';
import styles from './FacebookSharingDirective-hashed.scss';

var hashedTemplate = cssUtil.hashTemplate(templateStr, styles);
var fbClient = null;

var fn = function fn(FacebookService, TranslateService) {
    return {
        restrict: 'AE',
        template: hashedTemplate,
        link: function link(scope) {

            function translate(shareData) {
                Object.keys(shareData).filter(function (key) {
                    return shareData[key].startsWith('facebook.share-dialog');
                }).forEach(function (key) {
                    return TranslateService.translate({
                        object: shareData,
                        propName: key,
                        displayKey: shareData[key],
                        scope: scope
                    });
                });

                return shareData;
            }

            var shareData = translate(FacebookService.getShareDialogData());

            if (!fbClient) {
                FacebookService.getClient().then(function (client) {
                    fbClient = client; // preload to make popup a direct user action instead of a promise
                });
            }

            scope.share = function () {
                if (fbClient) {
                    var share = Object.assign({
                        method: 'share'
                    }, shareData);
                    fbClient.ui(share);
                }
            };

            scope.shareData = shareData;
        }
    };
};
fn.$inject = ['FacebookService', 'TranslateService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/facebook/FacebookSharingDirective.js
// module id = 1114
// module chunks = 0